import React from 'react'
import Banner from './component/Banner'
import WhatWeDo from './component/WhatWeDo'
import OurClient from './component/OurClient'
import OurClientRes from './component/OurClientRes'
import AboutUsSection from './component/AboutUsSection'
import Blogs from './component/Blogs'
import GetInTouch from './component/GetInTouch'
import Testimonials from './component/Testinonials'
import TawkToChat from './TawkToChat'
import ExactGalleryCarousel from './Achivement'
import Top_heading from './component/Top_heading'
import Component_Heading from './component/Component_Heading'
import './component/css/animation.css'
import { Helmet } from "react-helmet-async";




export default function Home() {
  return (
    <>

    <Helmet>
  {/* ✅ Meta Title */}
  <title>
    Best Digital Marketing Company in Dubai & India | RajDigi
  </title>

  {/* ✅ Meta Description */}
  <meta
    name="description"
    content="Award-winning digital marketing company in Dubai & India. RajDigi offers SEO, PPC, social media & web design for businesses across UAE & India. Get results!"
  />

  {/* ✅ Meta Keywords */}
  <meta
    name="keywords"
    content="best digital marketing company in dubai, digital marketing company in India"
  />
</Helmet>

    <Banner/>
   <WhatWeDo/>
   <OurClient/>
   <OurClientRes />
   <AboutUsSection/>
   <Blogs/>
   
   <Component_Heading heading="Our Achievement" para="Our Proud Moment: Receiving the Prestigious ‘New Gen Icon Award’ in Dubai
"/>
  
   <ExactGalleryCarousel/>
    <GetInTouch/>    
   
  
   <Testimonials/>
   <div className="blueStrip">
   </div>
   <TawkToChat/>

   
   
    </>
  )
}

